import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  CalculateByDays,
  CLEAR_COSTS,
  ForSubmit,
  GET,
  AdditionalInformation,
  GETCATEGORYSERVICEREQUEST,
  GETCATEGORYSUBITEMS,
  GET_FOOTER,
  CLEAR_FOOTER
} from '@hobs/constants/serviceRequests';

class ServiceRequests extends BaseReducer {
  static defaultState = {
    calculateByDays: null,
    item: {},
    forSubmit: {
      units: []
    },
    additionalInformation: {},
    categoryServiceRequest: {},
    categorySubitems: {},
    footer: null
  };
  constructor() {
    super(ServiceRequests.defaultState);

    this.actionMap = {
      [CalculateByDays.SUCCESS]: this.addCalculateByDaysResults,
      [CLEAR_COSTS.SUCCESS]: this.clearCosts,
      [ForSubmit.SUCCESS]: this.addForSubmitData,
      [GET.SUCCESS]: this.addServiceRequestItem,
      [AdditionalInformation.SUCCESS]: this.addAdditionalInformation,
      [GETCATEGORYSERVICEREQUEST.SUCCESS]: this.getCategoryServiceRequest,
      [GETCATEGORYSUBITEMS.SUCCESS]: this.getCategorySubitems,
      [GET_FOOTER.SUCCESS]: this.getFooter,
      [CLEAR_FOOTER.SUCCESS]: this.clearFooter
    };
  }

  addAdditionalInformation = (state, action) => {
    return Object.assign({}, state, {
      additionalInformation: {
        ...state.additionalInformation,
        [action.results.serviceRequestId]: action.results
      }
    });
  };

  addCalculateByDaysResults = (state, action) => {
    return Object.assign({}, state, { calculateByDays: action.results });
  };

  clearCosts = state => {
    return Object.assign({}, state, { calculateByDays: null });
  };

  addServiceRequestItem = (state, action) => {
    return Object.assign({}, state, { item: action.item });
  };

  addForSubmitData = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.results });
  };

  getCategoryServiceRequest = (state, action) => {
    return Object.assign({}, state, { categoryServiceRequest: action.item });
  };

  getCategorySubitems = (state, action) => {
    return Object.assign({}, state, { categorySubitems: action.payload });
  };

  getFooter = (state, action) => {
    return Object.assign({}, state, { footer: action.response });
  };

  clearFooter = (state) => {
    return Object.assign({}, state, { footer: null });
  }
}
export default new ServiceRequests().reducer;
